<template>
        <br>
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="demo-form">
        <el-form-item :label="$t('kbinfo.kbTitle', { msg: 'kbinfo.kbTitle' })" prop="title">
          <el-input type="textarea" :placeholder="$t('kbinfo.kbTitleD', { msg: 'kbinfo.kbTitleD' })" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('kbinfo.casKbCat', { msg: 'kbinfo.casKbCat'})">
          <div style="text-align: left;">
          <el-cascader 
          style="width: 24%"
          :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })"
          ref="refCascader"
          @change="handleCascader"
          :options="typeTree" 
          v-model="form.typeId" 
          :props="{
            value: 'id',
            label: 'type'
          }"
          ></el-cascader>
          </div>
        </el-form-item>
        <el-form-item :label="$t('kbType.tag', { msg: 'kbType.tag' })" >
          <div style="text-align: left;">
          <el-select v-model="form.tag" multiple :placeholder="$t('kbReview.table.selecttag', { msg: 'kbReview.table.selecttag' })"  style="width: 24%">
            <el-option
              v-for="item in tags"
              :key="item.id"
              :label="item.tag"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        </el-form-item>
        <!-- <el-form-item :label="$t('kbinfo.kbType', { msg: 'kbinfo.kbType' })" prop="typeId">
          <el-select style="width : 280px" v-model="form.typeId" :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })">
            <el-option
                    v-for="types in typeList"
                    :key="types.id"
                    :value="types.id"
                    :label="types.type"
                  />
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('kbinfo.solution', { msg: 'kbinfo.solution' })" prop="solution">
          <!-- <el-input type="textarea" :placeholder="$t('kbinfo.solutionD', { msg: 'kbinfo.solutionD' })" :autosize="{ minRows: 8, maxRows: 25}" v-model="form.solution"></el-input> -->
          <div style="border: 1px solid #ccc; z-index: 1001; ">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 400px; overflow-y: hidden;"
                v-model="form.solution"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onChange="onChange"
                @onCreated="onCreated"
               
            />
        </div>
          <!-- <Editor :solution="form.solution"></Editor> -->
        </el-form-item>
        <!-- <el-form-item label="状态：" prop="isPass">
          <el-radio v-model="form.isPass" label="2">待审核</el-radio>    
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">{{ $t('kbinfo.createNow', { msg: 'kbinfo.createNow' }) }}</el-button>
          <el-button @click="resetForm('form')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
        </el-form-item>
      </el-form>
  </template>
  <script>
  import { baseUrl_New } from '../../axios/urlconfig';
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
  import { i18nChangeLanguage } from '@wangeditor/editor'
  import { postRequest,getRequest } from '../../axios/axios';



  export default {
    components: { Editor, Toolbar },
      data() {
        return {
          editor: null,
          html: '',
          toolbarConfig: {
          // showLinkImg: false,
          //uploadImgShowBase64: false,
	        excludeKeys: [  //删除工具栏的插件
	          'insertVideo', // 删除视频
	          'uploadVideo',
	          'group-video',
	          //'insertImage',// 删除网络图片上传
	          'insertLink',// 删除链接
	          'codeBlock',// 删除代码块
            "emotion", //表情
            //"uploadImage",//删除图片
            //"insertTable", // 插入表格删除
	        ]
          },
          editorConfig: {
             placeholder: this.$t('issue.issueD', { msg: 'issue.issueD' }),
             readOnly: false, // 是否只允许阅读，不可编辑
		         //autoFocus: true,
             MENU_CONF: {
		          // 配置上传图片,只允许base64上传
		          uploadImage: {
		            server: baseUrl_New+'/oss/file/uploadEditor', // 上传接口
                fieldName: 'file',
		            allowedFileTypes: ['image/*'],
		            maxFileSize: 5 * 1024 * 1024, // 1M
		           // base64LimitSize: 1 * 1024 * 1024, // 1g 以下插入 base64
               // 将 meta 拼接到 url 参数中，默认 false
               // metaWithUrl: false,
              onSuccess(file, res) {          // JS 语法
                  console.log(`${file.name} 上传成功`, res)
              },

                // 自定义上传
             // customInsert(res, insertFn) {
              //insertFn(res[0].url); //同步插入,顺序不会乱
            //  },
                            
		            onError: (file, err, res) => {
		             this.$message.warning('当前选择的图片过大！请选择5M以内')
		            },
		          },
		     },  
         
          },
  
          mode: 'default', // or 'simple',
          isAdmin: sessionStorage.role.includes('管理员'),
          showDrawer: false,
          knowledgeBase: null, //单一知识库
          activeName: 'second',
          kbList: [
            {
            "type": "数据库",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-01 17:01:51"
            },
            {
            "type": "数据库1",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-04 17:01:51"
            },{
            "type": "数据库2",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-03 17:01:51"
            },{
            "type": "数据库3",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-02 17:01:51"
            }
        ],
        tableData: [],
        paginationDisabled: false,
        pageParam: {//分页参数
          pageNum: 1,//当前页
          pageSize: 10,//每页条目数据
        },
        total: 0,//总条目数
        pageSizes: [10, 20, 30, 40],//每页显示条目数列表
        searchParams: {
        pageNum: 1,//当前页
        pageSize: 10,//每页条目数据
        title: null,
        typeId: null,
        statsearchParamsus: null
        },
        title:'',
        typeList:[],
        form: {   //新增知识库
          title: '',
          typeId: '',
          tag:[],
          resource: '',
          isPass:0,
          solution: '',
        },
        rules:{
          title: [
            { required: true, message: this.$t('kbinfo.themeD', { msg: 'kbinfo.themeD' }), trigger: 'blur' }
          ],
          solution: [
            { required: true, message: this.$t('kbinfo.solutionD', { msg: 'kbinfo.solutionD' }), trigger: 'blur' }
          ],
        },
        typeTree:[],//知识类别两层结构
        creator:'',
        tags:[
        {
          id: '',
          tag: '',
          kbTypeId: '',
            }
        ],


        };
      },

      created(){
        //this.getAllList();
        //this.getTypeAll();
        this.getTypeTree();
        this.getCreatorName();
      },

      beforeUnmount() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
      },

      methods: {
        getCreatorName(){
          this.creator=sessionStorage.getItem('name');
        },
      onCreated(editor) {
          this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
          // i18nChangeLanguage(this.localStorage.getItem('language'));
          i18nChangeLanguage(localStorage.getItem('language'));
      },
      onChange(editor) {
      console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
       },
        handleClick(tab, event) {
          //console.log(tab, event);
        },
        //table样式
        tableRowClassName({row, rowIndex}) {
          if (rowIndex%4 === 1) {
            return 'warning-row';
          } else if (rowIndex%4 === 3) {
            return 'success-row';
          }
          return '';
        },

        //表格数据列表
         //获取所有的知识类别
       getAllList(){
        getRequest(baseUrl_New+'/kb/page/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.tableData = resultMap.list;
            this.total = resultMap.total;
        })
       },
        handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageParam.pageSize = val;
        this.getUsersList();
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageParam.pageNum = val;
        this.getAllList();
        },
        //知识类别种类
        getTypeAll(){
         /** getTypeAll().then(response=>{
            let result=response.data;  //这些都是多余的  需要删除
            this.typeList=result.list;
          }) */
          getRequest(baseUrl_New+'/kType/list').then(response=>{
            let resultMap = response;
            this.typeList=resultMap.list;
          })
        },
        handleReview(index,id){
          this.$confirm(this.$t('kbReview.toBeApproved', { msg: 'kbReview.toBeApproved' }),  this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText:  this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
            cancelButtonText:  this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            postRequest(baseUrl_New + `/kb/revertById/${id}`)
            .then(response=>{
              // console.log(response);
                if (response.code == 0){
                this.$message.success(this.$t('kbReview.approveS', { msg: 'kbReview.approveS' }))
                    this.getTypeAll();
                    this.getAllList();
                }else{
                this.message.error(this.$t('kbReview.approveF', { msg: 'kbReview.approveF' }));
                }
            })
        })
        },
        resetSearchParams(formName) {  //清空查询列表
        this.$refs[formName].resetFields();
        this.getAllList();
        this.paginationDisabled = false;
      },
      onSubmit(formName) { //新增知识库
        this.html = this.form.solution;
        this.$refs[formName].validate((valid) => {
        if (valid) {
        if(this.form.typeId === undefined || this.form.typeId === ''){
          this.$message.error(this.$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' }));
          return;
        }
        if(this.form.solution === undefined || this.form.solution === null || this.form.solution === '' || this.form.solution === '<p><br></p>'){
          this.$message.error(this.$t('kbinfo.kbInfoD', { msg: 'kbinfo.kbInfoD' }));
          return;
        }
        this.$confirm(this.$t('kbinfo.newtips', { msg: 'kbinfo.newtips' }),this.$t('exportIssue.mention', { msg: 'exportIssue.mention' }), {
        confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
        cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => { 
        postRequest(baseUrl_New + '/kb/addKB',{
          title:this.form.title,
          typeId:this.form.typeId,
          tag:this.form.tag,
          solution:this.form.solution,
          isPass:this.form.isPass,
          creator:this.creator,
        }).then(resp=>{
          this.$message.success(this.$t('kbinfo.newKbD', { msg: 'kbinfo.newKbD' }));
          this.resetForm('form')
        }).catch(err => {
          this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
        }) 
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('kbinfo.calcelnew', { msg: 'kbinfo.calcelnew' }),
        });
      });

      
          //  alert('submit!');
          } else {
           // console.log('error submit!!');
            return false;
          }
        });
       
      },
      resetForm(form) {
        this.$refs[form].resetFields();
        this.form.typeId = '';
        this.form.tag = [];
       // this.form=[];
        // this.form.title=null;
        // this.form.typeId=null;
        // this.form.type=null;
        // this.form.solution=null;
      },
      getAllByTitleKey(){
        const params = { params: { 'title': this.searchParams.title, 'typeId': this.searchParams.typeId } };
        getRequest(baseUrl_New+'/kb/titleKey', params
          // title:{title:this.searchParams.title}
        ).then(response=>{
          // console.log(response);
          this.tableData = response.data.list;
          this.total = response.data.count;
          this.paginationDisabled = true;
             //获得服务器端回传的map对象
          // let resultMap = response.data;
          //   //从集合中获取用户列表及总条目数
          // this.tableData = resultMap.list;
          //this.total = resultMap.total;
          })
      },
      // getAllBytype(){
      //   axios.get(baseUrl_New+'/kb/byTypeId/'+this.searchParams.typeId,
      //   ).then(response=>{
      //     // console.log(response);
      //     this.tableData = response.data.data.list;
           
      //     })
      // },
      handleOpenDrawer(val){
        this.showDrawer = true;
        this.knowledgeBase = val;
      },
      getTypeTree(){
        getRequest(baseUrl_New+'/kType/getType').then(response=>{
            let resultMap = response;
            this.typeTree=resultMap.data.typeTree;
          })
      },
      handleCascader(){
        this.form.typeId = this.$refs["refCascader"].getCheckedNodes()[0].value; //获取最后一个id
        this.form.tag = [];
        getRequest(baseUrl_New+'/kType/tag?id='+this.form.typeId).then(response=>{
            let resultMap = response.data;
            this.tags=resultMap.list;
          })
      },

      }
    };
  </script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-form-item__label-wrap {
  margin-left: 5px !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>